import React, { useState } from "react";
import { PlaySquare, ExternalLink, ChevronDown } from "lucide-react";
import VideoTutorial from "./VideoTutorial";
import { PLAYLIST_URL, VIDEOS } from "./conteudo/videos";

/**
 * Ajuda → "Vídeos tutoriais": a playlist inteira, um vídeo por linha. Clicar
 * abre o player ali mesmo (um por vez). `ids` = recorte da busca; sem busca,
 * todos.
 */
export default function TodosOsVideos({ ids }) {
  const [aberto, setAberto] = useState(null);
  const lista = ids || Object.keys(VIDEOS);
  if (!lista.length) return null;

  return (
    <div className="bg-card rounded-xl border shadow-sm overflow-hidden">
      <div className="px-4 py-4 border-b bg-muted/30 flex items-center gap-3">
        <div className="w-9 h-9 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
          <PlaySquare className="w-5 h-5 text-primary" />
        </div>
        <div className="min-w-0 flex-1">
          <h2 className="font-semibold text-base leading-tight">Vídeos tutoriais</h2>
          <p className="text-xs text-muted-foreground mt-0.5">
            {lista.length} vídeo{lista.length === 1 ? "" : "s"} curtos mostrando cada tela, no canal do Núcleo no YouTube.
          </p>
        </div>
        <a
          href={PLAYLIST_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="hidden sm:flex min-h-[36px] px-3 rounded-lg text-xs font-semibold bg-muted hover:bg-muted/70 transition-colors items-center gap-1.5 flex-shrink-0"
        >
          <ExternalLink className="w-3.5 h-3.5" /> Ver a playlist
        </a>
      </div>
      <div>
        {lista.map((id) => (
          <div key={id} className="border-b last:border-b-0">
            <button
              onClick={() => setAberto(aberto === id ? null : id)}
              className="w-full flex items-center gap-3 py-2.5 px-4 text-left hover:bg-muted/50 transition-colors"
            >
              {/* Shorts: a miniatura hqdefault é 4:3 com faixas pretas; cortada em
                  9:16 mostra só o vídeo em pé. */}
              <img
                src={`https://i.ytimg.com/vi/${id}/hqdefault.jpg`}
                alt=""
                loading="lazy"
                className={`${VIDEOS[id].horizontal ? "w-16 h-9" : "w-9 h-16"} object-cover rounded flex-shrink-0 bg-muted`}
              />
              <span className="text-sm font-medium flex-1">{VIDEOS[id].titulo}</span>
              <span className="text-xs text-muted-foreground">{VIDEOS[id].duracao}</span>
              <ChevronDown className={`w-4 h-4 text-muted-foreground transition-transform ${aberto === id ? "rotate-180" : ""}`} />
            </button>
            {aberto === id && (
              <div className="px-4 pb-4">
                <VideoTutorial id={id} />
              </div>
            )}
          </div>
        ))}
      </div>
      <a
        href={PLAYLIST_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="sm:hidden flex items-center justify-center gap-1.5 py-3 text-xs font-semibold text-primary border-t"
      >
        <ExternalLink className="w-3.5 h-3.5" /> Ver a playlist no YouTube
      </a>
    </div>
  );
}
